@if (formField(); as field) {
  <app-input
    [color]="hasError() ? 'red' : 'primary'"
    [label]="field.label"
    [(value)]="value"
    [required]="field.required!"
    [readonly]="field.readonly!"
    [disabled]="field.disabled!"
    [placeholder]="_placeholder()"
    [maxlength]="field.maxlength"
    [labelPosition]="field.labelPosition!"
  />
}
